import {
  CAR_DATA_MASTER_GET_BRANDS_BEGIN,
  CAR_DATA_MASTER_GET_BRANDS_SUCCESS,
  CAR_DATA_MASTER_GET_BRANDS_FAILURE,
  CAR_DATA_MASTER_GET_BRANDS_DISMISS_ERROR,
} from './constants';
import axios from "axios";
import { REACT_APP_API_ABM, REACT_APP_IMG } from '../../../common/config';
import { FILES_ENDPOINT } from 'cfgCommon/endpoints'
// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function getBrands(args = {}) {
  return async (dispatch) => { // optionally you can have getState as the second argument
    dispatch({
      type: CAR_DATA_MASTER_GET_BRANDS_BEGIN,
    });
    try {
      const res = await axios.get(REACT_APP_API_ABM + "/abms/brand" + args);
      if (res.data.success) {
        const brands = res.data.data;
        if (brands.length > 0) {
          brands.forEach(brand => {
            brand['logo'] = '';
            brand['canDelete'] = brand?.Models?.length === 0;
            brand['files'] = { 'LOGO': [] };
          });
          if (args !== '') {
            for (const brand of brands) {
              const resMaestro = await axios.get(FILES_ENDPOINT + '/MAESTRO/' + brand.id)
              if (resMaestro.data.data.length > 0) {
                resMaestro.data.data.forEach((item) => {
                  brand['files']['LOGO'].push(item);
                })
                if (brand['files']['LOGO'].length > 0) {
                  brand['logo'] = REACT_APP_IMG + '/' + brand['files']['LOGO'][0].url;
                }
              }
            }
            dispatch({
              type: CAR_DATA_MASTER_GET_BRANDS_SUCCESS,
              data: brands,
              pagination: res.data.pagination
            });
            return res;
          } else {
            dispatch({
              type: CAR_DATA_MASTER_GET_BRANDS_SUCCESS,
              data: brands,
              pagination: res.data.pagination
            });
            return res;
          }
        } else {
          dispatch({
            type: CAR_DATA_MASTER_GET_BRANDS_SUCCESS,
            data: [],
            pagination: res.data.pagination
          });
          return res;
        }
      } else {
        dispatch({
          type: CAR_DATA_MASTER_GET_BRANDS_FAILURE,
          data: [],
        });
        return res;
      }
    }
    catch (err) {
      dispatch({
        type: CAR_DATA_MASTER_GET_BRANDS_FAILURE,
        data: { error: err },
      });
      return err;
    }
  }
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissGetBrandsError() {
  return {
    type: CAR_DATA_MASTER_GET_BRANDS_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case CAR_DATA_MASTER_GET_BRANDS_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        getBrandsPending: true,
        getBrandsError: null,
      };

    case CAR_DATA_MASTER_GET_BRANDS_SUCCESS:
      // The request is success
      return {
        ...state,
        getBrandsPending: false,
        getBrandsError: null,
        brandListOrigin: [...action.data],
        brandList: [...action.data],
        brandsPagination: { ...action.pagination }
      };

    case CAR_DATA_MASTER_GET_BRANDS_FAILURE:
      // The request is failed
      return {
        ...state,
        getBrandsPending: false,
        getBrandsError: action.data.error,
        brandListOrigin: [],
        brandList: []
      };

    case CAR_DATA_MASTER_GET_BRANDS_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        getBrandsError: null,
      };

    default:
      return state;
  }
}
